
import {
  SET_SEARCH_KEY_SELECT,
  SET_SEARCH_OPTIONS,
  SET_SEARCH_PULLDOWN_VALUE,
  SET_SEARCH_INPUT_VALUE,
  SET_SELECTED_ADVANCED_FILTER_OPTIONS,
  SET_SORT_BY,
  SET_SORT_ORDER
} from '../actions/searchbox';

var initVal = {
  searchKeySelect:'',
  searchOptions:[],
  searchPulldownValue:'',
  searchInputValue:'',
  selectedAdvancedFilterOptions:[],
  sortBy:'exhibitor_name', // Default sort by exhibitor name
  sortOrder:'asc' // Default sort order ascending (A-Z)
}
export default function searchbox(state = initVal, {type, payload}) {
  switch (type) {
    case SET_SEARCH_KEY_SELECT:
      return {
        ...state,
        searchKeySelect: payload
    }
    case SET_SEARCH_OPTIONS:
      return {
        ...state,
        searchOptions: payload
    }
    case SET_SEARCH_PULLDOWN_VALUE:
      return {
        ...state,
        searchPulldownValue: payload
    }
    case SET_SEARCH_INPUT_VALUE:
      return {
        ...state,
        searchInputValue: payload
    }
    case SET_SELECTED_ADVANCED_FILTER_OPTIONS:
      return {
        ...state,
        selectedAdvancedFilterOptions: payload
    }
    case SET_SORT_BY:
      return {
        ...state,
        sortBy: payload
    }
    case SET_SORT_ORDER:
      return {
        ...state,
        sortOrder: payload
    }
    default:
        return state;
  }
}